import { formatDate } from 'shared/functions';
import { consolidatedPortfolioItemTypes } from 'shared/constants/portfolio/portfolioItemTypes';

const itemsCount = (dossierItem, itemsType) => {
  const count =
    dossierItem.itemsTypeCount &&
    consolidatedPortfolioItemTypes[itemsType]
      .map(type => dossierItem.itemsTypeCount[type])
      .reduce((a, b) => a + (b || 0), 0);
  return count || '-';
};

export const creditRatingPortfoliosToTableParser = data => {
  return data.map(item => [
    item.id,
    [item.id, item.name, item.description],
    item.noOfItems,
    itemsCount(item, 'issuers'),
    itemsCount(item, 'issues'),
    itemsCount(item, 'ratingNews'),
    itemsCount(item, 'researches'),
    formatDate(item.createdDate),
    formatDate(item.modifiedDate),
    [item.id, item.watchlistEnabled],
    null,
  ]);
};
